import './navBar.scss'
import templateUrl from './navBar.html'

/**
 * NavBar component for navigation between sub-sections
 *
 * @example
 *   <tmr-nav-bar items="[{ state: 'app.some.state', title: 'SOME.TRANSLATION.KEY'}]"></tmr-nav-bar>
 *
 * @type {ngComponent}
 * @prop {array<object>} items
 * @prop {string} items.state
 * @prop {string} items.title
 */
export const tmrNavBar = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrNavBarController',
  bindings: {
    items: '<',
  },
}

/**
 * Controller of component {@link tmrNavBar}.
 *
 * @type {ngController}
 */
export class tmrNavBarController {
  static ngType = 'controller'

  constructor($state) {
    'ngInject'
    Object.assign(this, { $state })
  }

  $onInit() {
    this.currentState = this.$state.current.name
  }
}
